module.exports = __webpack_public_path__ + "img/roll.9fb62ce5.png";